module.exports = __webpack_public_path__ + "img/4left-n-418215a7.png";